import { RuntimeLoader } from '@rive-app/react-canvas';

import { RIVE_WASM_RESOURCE } from './constants';

let didInit = false;

export function initRiveRuntime(): void {
  if (didInit) return;
  didInit = true;

  RuntimeLoader.setWasmUrl(RIVE_WASM_RESOURCE);
  RuntimeLoader.setWasmFallbackUrl(null);
}
